<template>
  <v-dialog
      v-model="show"
      persistent
      width="500"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Изменить номер телефона</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col v-if="!await_confirm" cols="12">
<!--            todo disable после отправки-->
            <v-btn
                v-if="currentUser.phone_number"
                block
                class="my-4"
                color="green"
                @click="codeRequest"
                depressed
                outlined
            >
              Отправить код подтверждения
            </v-btn>
            <v-text-field
                v-if="currentUser.phone_number"
                label="Код подтверждения"
                type="text"
                v-model="code"
                required
            ></v-text-field>

            <v-text-field
                label="Новый номер телефона"
                type="text"
                v-model="phone_number"
                required
                placeholder="7 (___) ___ __ __"
                v-mask="'7 (###) ###-##-##'"
            ></v-text-field>
          </v-col>

          <v-col v-else cols="12">
            Введите код, отправленный на указанный номер телефона

            <v-text-field
                label="Код подтверждения"
                type="text"
                v-model="token"
                required
            ></v-text-field>
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            variant="text"
            @click="show = false"
        >
          Отменить
        </v-btn>
        <v-btn
            v-if="!await_confirm"
            depressed
            outlined
            variant="text"
            @click="update"
        >
          Обновить
        </v-btn>

        <v-btn
            v-else
            depressed
            outlined
            variant="text"
            @click="confirm"
        >
          Подтвердить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ChangePhoneNumberDialog",
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      code: null,
      phone_number: null,

      await_confirm: false,
      token: null,
      type: 2,
    }
  },

  watch: {
    show(val) {
      if (!val) {
        this.clear();
      }
    },
  },

  computed: {
    ...mapGetters('user', ['currentUser']),
    show: {
      get() {
        return this.value;
      },

      set(show) {
        this.$emit('input', show);
      }
    },

    payload() {
      return {
        code: this.code,
        phone_number: this.phone_number,
      }
    },

    confirmPayload() {
      return {
        token: this.token,
        type: this.type,
      }
    },
  },

  methods: {
    ...mapActions({
      sendCodeRequest: 'user/sendCodeRequest',
      changePhoneNumber: 'user/changePhoneNumber',
      sendConfirm: 'user/sendConfirm',
    }),

    clear() {
      this.code = null;
      this.phone_number = null;
      this.token = null;
    },

    async update() {
      await this.changePhoneNumber(this.payload)
          .then(message => {
            console.log('message', message)
            this.await_confirm = true;
          });
    },

    codeRequest() {
      this.sendCodeRequest('phone_number');
    },

    confirm() {
      this.sendConfirm(this.confirmPayload)
          .then(() => {
            this.show = false;
          });
    }
  },
}
</script>

<style scoped>

</style>